import { setEvent } from '@/EventBus'
import { isStringSet } from '@/utils'

const BannerEvent = {
  eventName: 'set-banner',
  defaultState: {
    msgTxt: {
      type: String,
      value: '',
      default: '',
    },
    display: {
      type: Boolean,
      value: false,
      default: false,
    },
  },
  setBanner: function (message) {
    this.defaultState.msgTxt.value = message
    this.defaultState.display.value = isStringSet(message)
    setEvent(this.eventName, this.defaultState)
  },
  closeBanner: function () {
    const state = this.defaultState
    Object.keys(state).forEach((key) => (state[key].value = state[key].default))
    setEvent(this.eventName, state)
  },
}

export default BannerEvent
